/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { useSMOrganizationPage } from '../machines/pageContent';
import { Col, Row, Card, Button, Image } from 'react-bootstrap';
import {
  HeroSection,
  EditProfileModal,
  UpdateModal,
  Header,
} from '../components';
import { useSMupdateProfile } from '../machines/updateprofile';
import { VApplication } from '../../../application';
import { OrganizationPageService } from '../services';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.OrganizationPageService'
  ) as OrganizationPageService;
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const srv = getSrv();
  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});

  const theme = useTheme();

  const {
    organizationPageMachine,
    organizationPageState,
    organizationPageSend,
  } = useSMOrganizationPage({});

  const onRefresh = () => {
    organizationPageSend('TRIGGER_REFRESH', {});
  };
  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      if (!showModal) {
        setShowModal(true);
      }
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
    if (updateModal) {
      setUpdateModal(false);
    }
  };
  const onUpdateOrganization = (data: any) => {
    if (showModal) {
      setShowModal(false);
    }
    updateProfileSend('START', {
      payload: {
        ...data,
      },
    });
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'md'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onUpdateOrganization}
          onHide={() => setShowModal(false)}
          title={'Update Organization'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.editProfile?.FIELDS,
            layout: staticPageContentConfig?.editProfile?.layout,
            initialData:
              organizationPageState?.event?.data?.value?.organizationProfile
                ?.formDefaultData,
          }}
        />
      );
    }
    if (updateModal) {
      return (
        <UpdateModal
          {...(organizationPageState?.event?.data?.value || {})}
          showModal={updateModal}
          onDeny={onModalClose}
          // onAcknowledgement={onEditProfile}
        />
      );
    }
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header {...(staticPageContentConfig?.header || {})} />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    if (organizationPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <HeroSection
            {...(organizationPageState?.event?.data?.value
              ?.organizationProfile || {})}
            onHeroButtonClick={onButtonPress}
          />
        </>
      );
    }
    if (organizationPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    return null;
  };
  const _renderNotification = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (organizationPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.updateProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderModal()}
      {_renderErrorModals()}
      {_renderNotification()}
    </>
  );
};
